module.exports = __webpack_public_path__ + "img/2025-07.4be28d43.jpg";